export const environment = {
    production: true,
    apiOrigin: 'https://plugapps.dreamstep.in'
};
